/** @jsxImportSource preact */
import type { ComponentChildren } from 'preact';

// Links in chat messages, clickable: bare URLs, "<https://…>" and the AI's
// markdown "[tekst](https://…)". Long URLs are shortened on screen.

const LINK = /\[([^\]\n]{1,200})\]\((https?:\/\/[^\s)]+)\)|<(https?:\/\/[^\s<>]+)>|((?:https?:\/\/|www\.)[^\s<>"]+)/gi;

/** A bare URL's trailing punctuation belongs to the sentence, not the link. */
function trimUrl(url: string): string {
  let u = url.replace(/[.,;:!?'"»*]+$/, '');
  while (u.endsWith(')') && (u.match(/\(/g)?.length ?? 0) < (u.match(/\)/g)?.length ?? 0)) u = u.slice(0, -1);
  return u;
}

function shortUrl(url: string): string {
  const s = url.replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/$/, '');
  return s.length > 40 ? `${s.slice(0, 37)}…` : s;
}

export function linkify(text: string): ComponentChildren {
  if (!/https?:\/\/|www\./i.test(text)) return text;
  const out: ComponentChildren[] = [];
  let last = 0;
  for (const m of text.matchAll(LINK)) {
    const raw = m[4] ? trimUrl(m[4]) : null;
    const href = m[2] ?? m[3] ?? (raw!.startsWith('www.') ? `https://${raw}` : raw!);
    const label = m[1] ?? shortUrl(href);
    if (m.index! > last) out.push(text.slice(last, m.index));
    out.push(<a key={m.index} class="sa-url" href={href} target="_blank" rel="noopener noreferrer" title={href}>{label}</a>);
    last = m.index! + (raw ?? m[0]).length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
